import { Controller } from '@nestjs/common';

@Controller('payment-gateway')
export class PaymentGatewayController {}
